import { Button } from "@/components/shared/buttons/Button";
import { useOrganizationProxy } from "@/hooks/useOrganizationProxy";

interface IProps {
    /**
     * Organization to navigate to
     */
    organizationId: number;
}

/**
 * Button to navigate to the organization page
 */
export const OrganizationGo = ({ organizationId }: IProps) => {
    const { proxyIntoOrganization, isPending } = useOrganizationProxy();
    return (
        <Button
            variant={"contained"}
            onClick={() => proxyIntoOrganization(organizationId)}
            disableElevation
            sx={{
                borderRadius: 5,
            }}
            loading={isPending}
        >
            Go
        </Button>
    );
};
